import "@/index.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";

// Static — extracted to module scope so Toaster gets the same object ref
// every render instead of a fresh one.
const TOAST_OPTIONS = {
  style: {
    background: "#0F1C3F",
    border: "1px solid rgba(212,175,55,0.4)",
    color: "#F8FAFC",
  },
};
import { AuthProvider } from "@/context/AuthContext";
import HomePage from "@/pages/HomePage";
import AboutPage from "@/pages/AboutPage";
import ServicesPage from "@/pages/ServicesPage";
import ContactPage from "@/pages/ContactPage";
import TrackPage from "@/pages/TrackPage";
import AdminLoginPage from "@/pages/AdminLoginPage";
import AdminDashboardPage from "@/pages/AdminDashboardPage";
import ProtectedRoute from "@/components/layout/ProtectedRoute";
import PublicLayout from "@/components/layout/PublicLayout";

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Toaster
          position="bottom-right"
          theme="dark"
          duration={3000}
          toastOptions={TOAST_OPTIONS}
        />
        <Routes>
          <Route element={<PublicLayout />}>
            <Route path="/" element={<HomePage />} />
            <Route path="/about" element={<AboutPage />} />
            <Route path="/services" element={<ServicesPage />} />
            <Route path="/contact" element={<ContactPage />} />
            <Route path="/track" element={<TrackPage />} />
            <Route path="/track/:trackingId" element={<TrackPage />} />
          </Route>
          <Route path="/contact/admin" element={<AdminLoginPage />} />
          <Route
            path="/contact/admin/dashboard"
            element={
              <ProtectedRoute>
                <AdminDashboardPage />
              </ProtectedRoute>
            }
          />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
